module.exports = function() {
  return new Worker(__webpack_public_path__ + "3c49057f420ec896c37a.worker.js");
};